import React from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { useLocation, Outlet, Link } from 'react-router-dom';
import { i18next } from '@/config/i18n';

const Settings: React.FC = () => {
  const location = useLocation();

const tabRoutes = [
  { label: i18next.t('common:settings.general'), path: 'general' },
  { label: i18next.t('common:settings.shipment'), path: 'shipment' },
  { label: i18next.t('common:settings.optimization'), path: 'optimization' },
];
const currentTab = tabRoutes.findIndex(tab => location.pathname.endsWith(tab.path));

  return (
    <Box sx={{ p: 3, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: '1px solid #ccc' }}>
        <Typography variant="body2" sx={{ fontSize: 22, fontWeight: 600 }}>
          {i18next.t('common:settings.SettingText')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'grey', mb: 1 }}>
          {i18next.t('common:settings.managesetting')}
        </Typography>
      </Box>

      {/* Sticky Tabs */}
      <Tabs
        value={currentTab !== -1 ? currentTab : 0}
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          marginTop:'10px',
          backgroundColor: 'rgb(248, 191, 172)',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        {tabRoutes.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            component={Link}
            to={tab.path}
          />
        ))}
      </Tabs>

      <Box sx={{ flexGrow: 1, overflowY: 'auto', marginTop:'10px' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Settings;
